import React from 'react';
import { Button, List, Notice, Separator, Spinner, Text } from 'telia-front-react';
import { pushGaData } from '../common';
import { getImageSrcset } from '../common/util/ImageUtil';
import { CartItem } from './CartItem';
import HeaderJsxParser from './HeaderJsxParser';
import { formatPrice, getApplicablePrice } from './util/PriceUtil';
const checkoutGaData = {
    event: 'AutoEvent',
    eventCategory: 'Cart',
    eventAction: 'Checkout Click',
    eventLabel: 'Suundun ostukorvi'
};
const headerCart = (rootStore) => {
    const { cart, products, services, cartItemsCount, fetching, fetched, cartNotice, isVatDisabled, removeProduct, removeService, cartURL, getProductUrl } = rootStore.cartStore;
    const { app, lang } = rootStore.environmentStore;
    const { translate } = rootStore.translationsStore;
    const { section, setSection } = rootStore.sectionStore;
    const { currentPath } = rootStore.locationStore;
    if (app === 'itb') {
        return {
            id: 'cart',
            icon: '#cart',
            url: `/${lang}/ostukorv`,
            label: translate('header.actions.cart.label'),
            location: {
                xs: 'bottom',
                lg: 'top'
            }
        };
    }
    const CartHeader = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "h5" }, translate('cart.title'))));
    };
    const CartContent = () => {
        return (React.createElement(Text, null,
            React.createElement(CartOffer, null),
            (cartNotice === null || cartNotice === void 0 ? void 0 : cartNotice.showNotice) && (React.createElement(Notice, { type: cartNotice.type, size: "small", align: "center", className: "text-bold" }, translate(cartNotice.messageKey, 'global', cartNotice.messageParams))),
            fetching && React.createElement(Spinner, null),
            fetched &&
                (!cartItemsCount ? (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "text-center" }, translate('cart.empty')),
                    React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }))) : (React.createElement(List, { type: "unstyled", bordered: true, className: "text-small", fullWidth: true },
                    products.map(ProductCartItem),
                    services.map(ServiceCartItem))))));
    };
    const closeCartWhenSamePath = (event, path) => {
        if (section === 'cart' && currentPath === path) {
            event.preventDefault();
            setSection(null);
        }
    };
    const ProductCartItem = (product) => {
        return (React.createElement(CartItem, { key: `product-${product.id}`, name: product.name, amount: product.quantity, price: formatPrice(getApplicablePrice(product.totalPrice, product.totalPriceWithoutTax, !isVatDisabled), true, product.currency, !isVatDisabled, false, translate), url: getProductUrl(product.url), imageSrcSet: getImageSrcset(['40', '80'], product.picture), removable: !product.primaryOrderProductId, onClick: () => removeProduct(product.id), translate: translate, onLinkClick: closeCartWhenSamePath }));
    };
    const ServiceCartItem = (service) => {
        return (React.createElement(CartItem, { key: `service-${service.id}`, name: service.name, amount: service.quantity, price: formatPrice(getApplicablePrice(service.monthlyPayment, service.monthlyPaymentWithoutTax, !isVatDisabled), true, service.currency, !isVatDisabled, true, translate), url: getProductUrl(service.url), imageSrcSet: getImageSrcset(['40', '80'], service.picture), removable: true, onClick: () => removeService(service.id), translate: translate, onLinkClick: closeCartWhenSamePath }));
    };
    const CartFooter = () => {
        if (!fetching && cart && cartItemsCount) {
            return (React.createElement(Text, null,
                React.createElement("p", { className: "text-center" },
                    `${translate('cart.total')}: `,
                    React.createElement("span", { className: "text-bold" }, formatPrice(getApplicablePrice(cart.totalWithTax, cart.totalWithoutTax, !isVatDisabled), true, cart.currency, !isVatDisabled, false, translate))),
                React.createElement(Button, { url: cartURL, type: "expressive", text: translate('cart.goto'), iconLeft: "#cart", block: true, onClick: () => pushGaData(checkoutGaData) })));
        }
        return null;
    };
    const CartOffer = () => {
        const content = translate('cart.offer');
        return content === 'global:cart.offer' ? null : React.createElement(HeaderJsxParser, { content: content });
    };
    const cartItemsTag = () => {
        return +cartItemsCount
            ? {
                text: cartItemsCount,
                purpose: 'recommended'
            }
            : null;
    };
    return {
        id: 'cart',
        icon: '#cart',
        url: '',
        label: translate('header.actions.cart.label'),
        badge: cartItemsTag(),
        dropdownPadding: 'xsmall',
        dropdownHeader: React.createElement(CartHeader, null),
        dropdownContent: React.createElement(CartContent, null),
        dropdownFooter: React.createElement(CartFooter, null),
        location: {
            xs: 'bottom',
            lg: 'top'
        },
        showOverlay: false
    };
};
export default headerCart;
//# sourceMappingURL=HeaderCart.js.map